import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { Observable, combineLatest as observableCombineLatest } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { getAuthLoading, getAuthRefreshedAt } from '../../reducers/auth/auth-service.selectors';
import { AuthAction } from '../../reducers/auth/auth.action';

interface ResponseMeta {
  user_refreshed_at?: string;
}

@Injectable()
export class RefreshAuthInterceptor implements HttpInterceptor {
  private store = inject<Store<AppState>>(Store);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.body && event.body.meta) {
            this.refreshAuthenticatedUser(event.body.meta);
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse && err.error && err.error.meta) {
            this.refreshAuthenticatedUser(err.error.meta);
          }
        },
      ),
    );
  }

  private refreshAuthenticatedUser(meta: ResponseMeta) {
    if (!meta || !meta['user_refreshed_at']) {
      return;
    }
    const refreshedAtShouldBe = meta['user_refreshed_at'];

    observableCombineLatest(this.store.select(getAuthRefreshedAt), this.store.select(getAuthLoading))
      .pipe(first())
      .subscribe(([authRefreshedAt, loading]) => {
        if (loading || !authRefreshedAt) {
          return;
        }

        if (authRefreshedAt >= refreshedAtShouldBe) {
          return;
        }

        this.store.dispatch(AuthAction.refresh());
      });
  }
}
